import React, { useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import { UserProvider } from './contexts/UserContext';
import { NotificationProvider } from './contexts/NotificationContext';
import { LanguageProvider } from './contexts/LanguageContext';
import { initTelegramWebApp } from './utils/telegram';
import { useConfig } from './hooks/useConfig';
import FullscreenInfo from './components/common/FullscreenInfo/FullscreenInfo';

import './App.css';

// Pages
import Dashboard from './components/Dashboard/Dashboard';
import Transactions from './components/Transactions/Transactions';
import Arbitrage from './components/Arbitrage/Arbitrage';
import Licenses from './components/Licenses/Licenses';
import Referrals from './components/Referrals/Referrals';
import ExchangeManagement from './components/ExchangeManagement/ExchangeManagement';
import AdminDashboard from './components/AdminDashboard/AdminDashboard';
import SuccessPayments from './components/SuccessPayments/SuccessPayments';
import NotFound from './components/NotFound/NotFound';
import Unauthorized from './components/Unauthorized/Unauthorized';

// Layout
import MainLayout from './components/Layout/MainLayout';
// Protected Route
import ProtectedRoute from './components/common/ProtectedRoute/ProtectedRoute';

function App() {
  const config = useConfig();

  useEffect(() => {
    // Initialize Telegram Web App if running inside Telegram
    initTelegramWebApp();
  }, []);

  useEffect(() => {
    if (config.css) {
      document.documentElement.style.setProperty('--accent-color', config.css['accent-color']);
      document.documentElement.style.setProperty('--accent-gradient', config.css['accent-gradient']);
      
      console.log(config.css);
    }
  }, [config]);

  return (
    <UserProvider>
      <LanguageProvider>
        <NotificationProvider>
          <div className="app">
            {/* <FullscreenInfo /> */}
            <Routes>
              {/* Публичный маршрут для неавторизованных пользователей */}
              <Route path="/unauthorized" element={<Unauthorized />} />
              <Route path="/success-payments" element={<SuccessPayments />} />

              {/* Защищенные маршруты, доступные только авторизованным пользователям */}
              <Route element={<ProtectedRoute />}>
                <Route path="/" element={<MainLayout />}>
                  <Route index element={<Dashboard />} />
                  <Route path="transactions" element={<Transactions />} />
                  <Route path="arbitrage" element={<Arbitrage />} />
                  <Route path="licenses" element={<Licenses />} />
                  <Route path="referrals" element={<Referrals />} />
                  <Route path="exchanges" element={<ExchangeManagement />} />
                  <Route path="admin" element={<AdminDashboard />} />
                  <Route path="*" element={<NotFound />} />
                </Route>
                {/* Страница успешного платежа без основного лейаута */}
              </Route>
            </Routes>
          </div>
        </NotificationProvider>
      </LanguageProvider>
    </UserProvider>
  );
}

export default App; 